import { jsx as _jsx } from "react/jsx-runtime";
import { Divider, useDevice } from 'seagull';
export const TriageDivider = (param)=>{
    let { testId } = param;
    const { isMobileDevice } = useDevice();
    if (isMobileDevice) return null;
    return /*#__PURE__*/ _jsx("div", {
        "data-testid": testId,
        children: /*#__PURE__*/ _jsx(Divider, {
            margin: 0
        })
    });
};
